<div fxLayoutAlign="start">
  <button id="new-payform-button" mat-button="" color="primary" (click)="driverPayService.createNewPayform()">
    + NEW PAYFORM
  </button>
</div>
<ngx-presentation-framework-screen [screenId]="screenId" [config]="config"> </ngx-presentation-framework-screen>
